import { FC, ReactNode } from "react";

export type BreakdownCardHeader = { icon?: ReactNode; label: ReactNode; value?: ReactNode };
export type BreakdownCardRow = { label: ReactNode; value: ReactNode };

const BreakdownCard: FC<{ header?: BreakdownCardHeader; rows: BreakdownCardRow[] }> = ({ header, rows }) => {
  return (
    <div className="flex flex-col gap-3 rounded-md bg-background-default p-3 outline outline-border-subtle">
      {header && (
        <>
          <div className="flex items-center justify-between gap-2">
            <div className="text-font-default flex items-center gap-2 text-sm font-semibold">
              {header.icon && <span className="text-icon-active">{header.icon}</span>}
              {header.label}
            </div>
            {header.value !== undefined && <div className="text-font-default text-base font-semibold">{header.value}</div>}
          </div>
          <div className="h-px w-full bg-border-default" />
        </>
      )}
      <div className="flex flex-col gap-2">
        {rows.map((row, i) => (
          <div key={i} className="flex items-center justify-between gap-2">
            <div className="text-font-subtle text-sm">{row.label}</div>
            <div className="text-font-default text-sm font-semibold">{row.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BreakdownCard;
